// Code generated by Slice Machine. DO NOT EDIT.

import CampaignPhotoUpload from "./CampaignPhotoUpload";
import AuthorBioSection from "./AuthorBioSection";
import BannerContentPage from "./BannerContentPage";
import BecomeABussinessCusomer from "./BecomeABussinessCusomer";
import BlockOfTextWithHeader2Column from "./BlockOfTextWithHeader2Column";
import BlogContentAuthor from "./BlogContentAuthor";
import BlogContentRichTextWithBanner from "./BlogContentRichTextWithBanner";
import Breadcrumbs from "./Breadcrumbs";
import BusinessRegistrationForm from "./BusinessRegistrationForm";
import BusinuessCusotmerAdvantages from "./BusinuessCusotmerAdvantages";
import ContactUsForm from "./ContactUsForm";
import ContentBlock from "./ContentBlock";
import CountdownTimer from "./CountdownTimer";
import CustomerReviewsBig from "./CustomerReviewsBig";
import FaqSection from "./FaqSection";
import HeroBanner from "./HeroBanner";
import ImageAndTextContent from "./ImageAndTextContent";
import OrderFeedbackForm from "./OrderFeedbackForm";
import PaymentOptionsHorizontal from "./PaymentOptionsHorizontal";
import PhotoCarouselWithRichText from "./PhotoCarouselWithRichText";
import PopularProducts from "./PopularProducts";
import RichText from "./RichText";
import SelectedCategories from "./SelectedCategories";
import UspBarImageAndText from "./UspBarImageAndText";
import WhoIsWovarAndWhyWovar from "./WhoIsWovarAndWhyWovar";
import KlaviyoEmbedForm from "./KlaviyoEmbedForm";
import WovarTeam from "./WovarTeam";

export {
  CampaignPhotoUpload,
  AuthorBioSection,
  BannerContentPage,
  BecomeABussinessCusomer,
  BlockOfTextWithHeader2Column,
  BlogContentAuthor,
  BlogContentRichTextWithBanner,
  Breadcrumbs,
  BusinessRegistrationForm,
  BusinuessCusotmerAdvantages,
  ContactUsForm,
  ContentBlock,
  CountdownTimer,
  CustomerReviewsBig,
  FaqSection,
  HeroBanner,
  ImageAndTextContent,
  KlaviyoEmbedForm,
  OrderFeedbackForm,
  PaymentOptionsHorizontal,
  PhotoCarouselWithRichText,
  PopularProducts,
  RichText,
  SelectedCategories,
  UspBarImageAndText,
  WhoIsWovarAndWhyWovar,
  WovarTeam,
};

export const components = {
  campaign_photo_upload: CampaignPhotoUpload,
  authorBioSection: AuthorBioSection,
  banner_content_page: BannerContentPage,
  become_a_bussiness_cusomer: BecomeABussinessCusomer,
  block_of_text_with_header2_column: BlockOfTextWithHeader2Column,
  blog_content_author: BlogContentAuthor,
  blog_content_rich_text_with_banner: BlogContentRichTextWithBanner,
  breadcrumbs: Breadcrumbs,
  business_registration_form: BusinessRegistrationForm,
  businuess_cusotmer_advantages: BusinuessCusotmerAdvantages,
  contact_us_form: ContactUsForm,
  content_block: ContentBlock,
  countdown_timer: CountdownTimer,
  customer_reviews_big: CustomerReviewsBig,
  faq_slice: FaqSection,
  hero_banner: HeroBanner,
  image_and_text_content: ImageAndTextContent,
  klaviyo_embed_form: KlaviyoEmbedForm,
  order_feedback_form: OrderFeedbackForm,
  payment_options_horizontal: PaymentOptionsHorizontal,
  photo_carousel_with_rich_text: PhotoCarouselWithRichText,
  popular_products: PopularProducts,
  rich_text: RichText,
  selected_categories: SelectedCategories,
  usp_bar_image_and_text: UspBarImageAndText,
  who_is_wovar_and_why_wovar: WhoIsWovarAndWhyWovar,
  wovar_team: WovarTeam,
};
